var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameConsultation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 95,
    viewBox: "0 0 68 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_1999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9697 0H2.32971C1.04143 0 0 1.02822 0 2.30017V92.7074C0 93.9794 1.04143 95.0076 2.32971 95.0076H64.9697C66.258 95.0076 67.2994 93.9794 67.2994 92.7074V2.30017C67.2917 1.02822 66.2502 0 64.9697 0Z",
    fill: "url(#paint0_linear_306_1999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.858 4.09766H6.43377C5.18406 4.09766 4.16577 5.10303 4.16577 6.34451V81.0923C4.16577 82.3338 5.18406 83.3316 6.43377 83.3316H60.858C62.1155 83.3316 63.126 82.3262 63.126 81.0923V6.34451C63.126 5.10303 62.1155 4.09766 60.858 4.09766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7736 39.636H22.5256C21.5073 39.636 20.6819 38.8211 20.6819 37.8157V15.8422C20.6819 14.8369 21.5073 14.0219 22.5256 14.0219H44.7736C45.7919 14.0219 46.6173 14.8369 46.6173 15.8422V37.8081C46.6173 38.8135 45.7919 39.636 44.7736 39.636Z",
    fill: "url(#paint1_linear_306_1999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6498 92.5475C35.5414 92.5475 37.0749 91.0335 37.0749 89.1658C37.0749 87.2981 35.5414 85.7841 33.6498 85.7841C31.7581 85.7841 30.2246 87.2981 30.2246 89.1658C30.2246 91.0335 31.7581 92.5475 33.6498 92.5475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0356 51.015H14.2559C13.2762 51.015 12.4739 50.2229 12.4739 49.2556C12.4739 48.2883 13.2762 47.4962 14.2559 47.4962H53.0279C54.0076 47.4962 54.8099 48.2883 54.8099 49.2556C54.8099 50.2229 54.0153 51.015 53.0356 51.015Z",
    fill: "url(#paint2_linear_306_1999)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M46.4708 60.764H13.608C12.9831 60.764 12.4817 60.2613 12.4817 59.652V59.5302C12.4817 58.9132 12.9908 58.4182 13.608 58.4182H46.4708C47.0957 58.4182 47.5971 58.9208 47.5971 59.5302V59.652C47.6048 60.2613 47.0957 60.764 46.4708 60.764Z",
    fill: "url(#paint3_linear_306_1999)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M40.2144 66.9562H13.4999C12.9367 66.9562 12.4739 66.4992 12.4739 65.9432V65.6081C12.4739 65.0521 12.9367 64.5951 13.4999 64.5951H40.2067C40.7699 64.5951 41.2327 65.0521 41.2327 65.6081V65.9432C41.2327 66.4992 40.7699 66.9562 40.2144 66.9562Z",
    fill: "url(#paint4_linear_306_1999)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M43.578 72.6914H13.5617C12.9677 72.6914 12.4817 72.2116 12.4817 71.6251V71.4119C12.4817 70.8254 12.9677 70.3456 13.5617 70.3456H43.578C44.172 70.3456 44.658 70.8254 44.658 71.4119V71.6251C44.658 72.204 44.172 72.6914 43.578 72.6914Z",
    fill: "url(#paint5_linear_306_1999)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7165 26.1208C35.9441 26.1208 37.7497 24.3141 37.7497 22.0854C37.7497 19.8566 35.9441 18.05 33.7165 18.05C31.4889 18.05 29.6832 19.8566 29.6832 22.0854C29.6832 24.3141 31.4804 26.1208 33.7165 26.1208ZM33.7165 28.1385C31.0248 28.1385 25.6499 29.4892 25.6499 32.1739V33.1869C25.6499 33.7441 26.1055 34.2 26.6624 34.2H40.7874C41.3443 34.2 41.7999 33.7441 41.7999 33.1869V32.1739C41.783 29.4977 36.4081 28.1385 33.7165 28.1385Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_1999",
    x1: 4.07698,
    y1: 45.0301,
    x2: 67.3445,
    y2: 50.4539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_306_1999",
    x1: 18.6707,
    y1: 19.2924,
    x2: 48.4653,
    y2: 34.6685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0856277,
    stopColor: "#A3F0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2972,
    stopColor: "#8AE7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5161,
    stopColor: "#77E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    stopColor: "#6DDDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69DCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_306_1999",
    x1: 54.8136,
    y1: 49.257,
    x2: 12.4812,
    y2: 49.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_306_1999",
    x1: 47.6026,
    y1: 59.5877,
    x2: 12.4812,
    y2: 59.5877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_306_1999",
    x1: 41.2335,
    y1: 65.7799,
    x2: 12.4812,
    y2: 65.7799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_306_1999",
    x1: 44.6573,
    y1: 71.5124,
    x2: 12.4813,
    y2: 71.5124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_1999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.2917,
    height: 95,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameConsultation);
export default __webpack_public_path__ + "static/media/Frame-Consultation.9f50dcc843d2e6666a20c82ea4c3680f.svg";
export { ForwardRef as ReactComponent };